<section class="content">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-xs-9 col-sm-9 col-md-9 col-lg-7 col-xl-7">
          <ul class="breadcrumb breadcrumb-style">
            <li class="breadcrumb-item">
              <h4 class="page-title">View Prescription</h4>
            </li>
            <li
              *ngIf="currentUser.UserRoleId == 3 ||currentUser.UserRoleId == 4"
              class="breadcrumb-item bcrumb-1"
            >
              <a routerLink="/pharmacist/dashboard">
                <i class="fas fa-home"></i> Home</a
              >
            </li>
            <li
              *ngIf="currentUser.UserRoleId == 2"
              class="breadcrumb-item bcrumb-1"
            >
              <a routerLink="/doctor/dashboard">
                <i class="fas fa-home"></i> Home</a
              >
            </li>
            <li
              *ngIf="currentUser.UserRoleId == 2"
              class="breadcrumb-item bcrumb-2"
            >
              <a routerLink="/doctor/prescription/list" onClick="return false;"
                >Prescription</a
              >
            </li>
            <li
              *ngIf="currentUser.UserRoleId != 2"
              class="breadcrumb-item bcrumb-2"
            >
              <a
                routerLink="/pharmacist/prescription/list"
                onClick="return false;"
                >Prescription</a
              >
            </li>
            <li class="breadcrumb-item active">View Prescription</li>
          </ul>
        </div>
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-5 col-xl-5">
          <a (click)="back()"class="btn btn-group-lg btn-outline-secondary float-end"><i class="fa fa-angle-left"></i> Back</a>
          <a *ngIf="currentUser.UserRoleId == 2" (click)="createToken(prescriptionDetails);" class="btn btn-group-lg btn-outline-secondary float-end  m-r-10">Generate Ticket</a>
          <a (click)="printPrescription()" class="btn btn-group-lg btn-outline-secondary float-end  m-r-10">Print Prescription</a>
        </div>
        
      </div>
    </div>
    <div class="row clearfix">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="card">
          <div class="body">
            <div class="row">
              <div class="col-md-12">
                <div class="white-box">
                  <!-- <h3>
                      <b>INVOICE</b>
                      <span class="pull-right">#345766</span>
                    </h3>
                    <hr /> -->
                  <div class="row">
                    <div class="col-md-12">
                      <div class="pull-left">
                        <img
                          src="assets/images/prescription.png"
                          alt="logo"
                          class="logo-default"
                          height="100"
                        />
                      </div>
                      <div class="pull-right text-end">
                        <address>
                          <p class="font-24 font-bold m-0">
                            {{prescriptionDetails?.Doctor?.PracticeName}}
                          </p>
                          <p class="font-weight-500 m-0">
                            Dr.
                            {{this.prescriptionDetails.doctorUserAccount?.FirstName}}&nbsp;{{this.prescriptionDetails.doctorUserAccount?.LastName}}
                          </p>
                          <p class="text-muted m-0 m-l-30">
                            {{this.prescriptionDetails.doctorUserAccount?.AddressLine1}}
                            <br />
                            {{this.prescriptionDetails.doctorUserAccount?.AddressLine2}}
                          </p>
                          <p class="text-muted m-l-30">
                            Phone No:
                            {{this.prescriptionDetails?.doctorUserAccount?.Phone}}
                          </p>
                        </address>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="pull-left">
                        <p class="addr-font-h3 font-bold">Patient Details</p>
                        <p class="text-muted m-l-5">
                          Name :&nbsp;
                          {{prescriptionDetails?.Patient?.FirstName}}&nbsp;{{prescriptionDetails?.Patient?.LastName}}
                          <br />
                          Gender : {{ prescriptionDetails?.patient?.Gender !=
                          ''?(prescriptionDetails?.patient?.Gender ==
                          'M'?'Male':'Female'):' -' }}<br />
                          Age : {{ prescriptionDetails?.Patient?.Age }}<br />
                          Phone : {{ prescriptionDetails?.Patient?.Phone !=
                          null? prescriptionDetails?.Patient?.Phone:' -'}}<br />
                          P-{{prescriptionDetails?.Prescription?.PrescriptionNo}}
                        </p>
                      </div>
                      <div class="pull-right"></div>
                    </div>
                    <div class="col-md-12 m-0">
                      <div class="pull-right">
                        <p>Collections Location : <strong>{{collectionLocation}}</strong></p>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="table-responsive m-t-40">
                        <table class="table table-hover">
                          <thead>
                            <tr>
                              <th class="text-center">Sr. No.</th>
                              <th>Drug</th>
                              <th class="">Description</th>
                              <th class="">#Refill</th>
                              <th class="">Status</th>
                              <th class="">Remark</th>
                              <th class="">Replacement Information</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              *ngFor="let drug of this.prescriptionDetails.drugList;let i = index;"
                            >
                              <td
                                class="align-baseline"
                                style="text-align: center;"
                              >
                                {{i+1}}
                              </td>
                              <td class="align-baseline">
                                {{drug?.DrugName}}
                                <br />
                                <span class="font-11 font-italic">
                                  {{drug?.Manufacturer}}
                                </span>
                              </td>
                              <td class="align-baseline">
                                {{drug?.Description}}
                              </td>
                              <td class="align-baseline">
                                {{(drug?.Refill == null || drug?.Refill ==
                                '')?'-':drug?.Refill}}
                              </td>
                              <td class="align-baseline">
                                <option>{{drug.Status}}</option>
                              </td>
                              <td class="align-baseline">
                                <span
                                  *ngIf="GetRemark(drug.DrugId) == undefined"
                                  >-</span
                                >
                                <span
                                  *ngIf="GetRemark(drug.DrugId) != undefined"
                                  matTooltip="{{GetRemark(drug.DrugId).Remark}}"
                                  matTooltipPosition="left"
                                  >{{GetRemark(drug.DrugId).Remark.length>25?
                                  (GetRemark(drug.DrugId).Remark |
                                  slice:0:25)+'..':(GetRemark(drug.DrugId).Remark)}}
                                </span>
                              </td>
                              <td class="align-baseline">
                                <!-- <a
                                  style="cursor: pointer;"
                                  class="text-primary"
                                  (click)="replacementModal(drug)"
                                  >Replace</a
                                > -->
                                <span
                                  *ngIf="IsDrugExist(drug.DrugId) == undefined"
                                  >-</span
                                >
                                <a
                                  *ngIf="IsDrugExist(drug.DrugId) != undefined"
                                  style="cursor: pointer;"
                                  class="text-primary"
                                  (click)="summaryModal(drug)"
                                  >Summary</a
                                >
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="pull-left">
                        <p class="">
                          <i class="fa fa-calendar"></i><b> &emsp;Date :</b>
                          {{prescriptionDetails?.Prescription?.CreatedDate |
                          date:'MM/dd/yy'}}
                        </p>
                      </div>
                      <div class="pull-right text-center">
                        <div class="col ml-5 float-left form-section p-0">
                          <div class="signature-wrapper">
                            <img
                              [src]="prescriptionDetails.Prescription?.Signature"
                              class="border-radius-5"
                              style="box-shadow: 0 0px 2px #212529;"
                              alt=""
                            />
                            <br />
                            <span>Signature</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                      <h5 class="">Comments:</h5>
                      <div>
                        {{prescriptionDetails.Prescription?.Comment == null ||
                        prescriptionDetails.Prescription?.Comment ==
                        ''?'-':prescriptionDetails.Prescription?.Comment}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #printPrescriptionConfirm class="newprint">
    <div style="display: flex;
    align-items: center;
    justify-content: center;
    height: 199px;">
      <div class="row delete-confirm ">
        <div class="col-sm-12 mb-3 ">
          Are you handing over the presecription to patient
        </div>
        <div class="col-sm-12">
          <div class="row">
            <div class="col-sm-5">
              <button
                type="button"
                (click)="prescriptionStatusChange(prescriptionDetails)"
                class="btn btn-sm btn-primary me-3">
                Yes
              </button>
    
              <button
                type="button"
                (click)="prescriptionNotStatusChange(prescriptionDetails)"
                class="btn btn-sm btn-secondary">
                No
              </button>
            </div>
          </div>
        </div>
        <div class="col-sm-12 mt-3 font-13">
          *Please note, if you are handing over the prescription to patient, it will be assumed that medicines will not be filled at "Pharmacy Name" necessarily and hence it will not be tracked.
        </div>
      </div>
    </div>
  </ng-template>
  <div style="z-index: -9;position: absolute;left: 0;top: 33%;">
  <div class="invoice-POS">
    <div  id="pdfTable" #pdfTable>
        <div id="top" >
          <div class="info rotate">
            <div class="tname">{{prescriptionDetails?.Patient?.FirstName}}&nbsp;{{prescriptionDetails?.Patient?.LastName}}</div>
            <div class="tno">P-{{prescriptionDetails?.Prescription?.PrescriptionNo}}</div>
            <div class="tdate">{{currentDate | date:'MM/dd/yy'}}</div>
          </div><!--End Info-->
        <div class="rotate_watermark">
          <div class="watermark"><img alt="logo" class="watermark-img" src="../../../../../assets/images/logo-1.jpg"></div>
        </div>
        </div>
      </div>
      <button class="btn btn-primary" (click)="downloadAsPDF();">Export To PDF</button>
    </div>
  </div>

  <!-- <div class="row content-pdf" id="pdfTable" #pdfTable >
    <div class="col-md-12">
      <div class="tname">{{prescriptionDetails?.Patient?.FirstName}}&nbsp;{{prescriptionDetails?.Patient?.LastName}}</div>
            <div class="tno">P-{{prescriptionDetails?.Prescription?.PrescriptionNo}}</div>
            <div class="tdate">{{currentDate | date:'MM/dd/yy'}}</div>
    </div>
  </div> -->
</section>
